import returnCorrectWPUrl from 'components/Dashboard/utilities/returnCorrectWPUrl';
import MCPInformationBox from 'components/Pricing/MCPInformationBox';
import getAppSite, { comprehensiveText } from 'utils/getAppSite';

const AgencyLoggedOut = () => {
  const features = [
    `${comprehensiveText({ uppercase: true })} political monitoring service`,
    'Fully-integrated prospecting platform to help you win new business',
    'Real-time transcription and alerts from debates and committees',
    'Early access to news, shared prior to publication when permitted',
    'Fully-integrated CRM to manage and track stakeholder engagement',
    'Map stakeholders by influence, interest and sentiment for any client issue',
    'Data analysis platform to drill into and share political data on any issue',
    'Create customised PDF reports for clients with live political data',
    'Campaigning tools including lobbying platform and embedded news feeds',
    'AI assistant to create lobbying material, summarise updates and more',
  ];
  return (
    <div className='mx-auto' style={{ maxWidth: '840px' }}>
      <div className='mt-4'>
        <MCPInformationBox agency={true} />
      </div>
      <div className='box-shadow p-4 p-md-5 mt-5 rounded '>
        <div className='d-md-flex align-items-lg-center justify-content-between text-left'>
          <h3 className='mb-0 title-h3-bold pt-3 pt-lg-0'>PolicyMogul for agencies and consultants</h3>
          <button
            className={`general-button rounded-pill outline-active-button px-4 py-2 mt-3 mt-md-0`}
            onClick={() => {
              window.location.assign(getAppSite() === 'usa' ? '/' : `${returnCorrectWPUrl()}/demo`);
            }}
          >
            {'Book a demo'}
          </button>
        </div>
        <ul className='policy-list text-left title-h5-m mt-4 px-0 mb-0'>
          {features.map((item, index) => {
            return (
              <li
                className={`${index === features?.length - 1 ? '' : 'mb-3'} py-1 text-main-blue d-flex`}
                key={`list-item-${index}`}
              >
                <span className='inline-block title-h2 mr-3 icon-small-check agency-small-check' />
                <span>{item}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default AgencyLoggedOut;
